export default __webpack_public_path__ + "static/media/Prime.031c87fd.png";